module.exports = __webpack_public_path__ + "img/login-logo.d1a8a362.png";